/**
 * Static images for marketing pages. Files live under `web-client/public/images/`.
 */
export const ABOUT_PAGE_IMAGES = {
  /** Hero on `/about` */
  hero: '/images/about/about.png',
  /** "Our Story" section */
  ourStory: '/images/about/our-story.png',
} as const;

export const CONTACT_PAGE_IMAGE = '/images/contact/contact.png';
